<template>
    <div style="max-width: 600px; margin: auto; text-align: left;">
        <FieldHeader class="q-mb-xs" v-if="showHeader" :field="field" />
        <div class="column items-center q-gutter-y-sm">
        <div class="row items-center q-gutter-x-md">
            <star-rating
                :increment="field.options?.allowHalf ? 0.5 : 1"
                :max-rating="field.options?.count || 5"
                :show-rating="false"
                :rating="modelValue || 0"
                :read-only="readOnly"
                @update:rating="onUpdate"
            />
            <span :class="(modelValue ? ' text-grey-7 text-h4' : 'text-grey-5 text-h6')" style="min-width: 50px; text-align: left;">
                {{ (modelValue?.toFixed(1) ?? 'None') }}
            </span>
        </div>
        <q-btn
            v-if="modelValue && !field.required"
            flat
            label="Reset"
            color="primary"
            @click="resetRating"
            class="q-mt-sm"
        />
        </div>
    </div>
</template>

<script>
    import StarRating from 'vue-star-rating';
    import FieldHeader from './FieldHeader.vue';

    export default {
        name: 'StarRatingField',
        components: { StarRating, FieldHeader },
        props: {
            field: {
                type: Object,
                required: true,
            },
            modelValue: {
                type: Number,
                default: 0,
            },
            readOnly: {
                type: Boolean,
                default: false,
            },
            showHeader: {
                type: Boolean,
                default: true,
            },
        },
        emits: ['update:modelValue', 'blur'],
        methods: {
            onUpdate(value) {
                this.$emit('update:modelValue', value);
                this.$emit('blur');
            },
            resetRating() {
                this.$emit('update:modelValue', null);
                this.$emit('blur');
            },
        },
    };
</script>